import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { NumberFormatMoney } from "../useForm";
import format from 'format-number'
import { Alert, Autocomplete, Box, Button, Collapse, Grid, IconButton, InputAdornment, Link, TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';
import es from "date-fns/locale/es";
import PreviewTwoToneIcon from '@mui/icons-material/PreviewTwoTone';

export default function Adquisicion(props) {
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [cotizacion, setCotizacion] = useState(null)
    const [productoServicio, setProductoServicio] = useState(null)
    const [expiroFecha, setExpiroFecha] = useState(false)
    const [sinConfiguracionFechas, setSinConfiguracionFechas] = useState(false)
    const [proyectos, setProyectos] = useState([])
    const [proyecto, setProyecto] = useState(null)
    const [adquisicion, setAdquisicion] = useState({})
    const [fechaExpiracion, setFechaExpiracion] = useState(null)
    const [fechas, setFechas] = useState(null)
    const [partidasProyecto, setPartidasProyecto] = useState([])
    const [partida, setPartida] = useState(null);
    const [monto, setMonto] = useState(null);
    const [observaciones, setObservaciones] = useState(null);
    const [justificacion, setJustificacion] = useState(null);
    const [errorMonto, setErrorMonto] = useState(false)
    const [helperTextMonto, setHelperTextMonto] = useState('')
    const [errorProyectoSinPartidas, setErrorProyectoSinPartidas] = useState(false)
    const [helperTextProyectoSinPartidas, setHelperTextProyectoSinPartidas] = useState('')
    const [errorCotizacion, setErrorCotizacion] = useState(false)
    const [helperTextCotizacion, setHelperTextCotizacion] = useState('')
    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [errorPedido, setErrorPedido] = useState(false)
    const [helperTextPedido, setHelperTextPedido] = useState('')
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [loading, setLoading] = useState(false);
    const [rutaPDF, setRutaPDF] = useState(false)
    const [pedido, setPedido] = useState(false)
    const [severity, setSeverity] = useState('error')

    const colocarNombreFactura = (ruta) => {
        if (!ruta || ruta === '')
            return ''
        const indice = Number(ruta.indexOf("factura")) + 9
        return ruta.slice(indice)

    }
    const colocarNombreCotizacion = (ruta) => {
        if (!ruta || ruta === '')
            return ''
        const indice = Number(ruta.indexOf("cotizaciones")) + 13
        return ruta.slice(indice)

    }
    const mostrarDocumento = async (value, tipo) => {
        //console.log(`value en desplegarDocumentoPDF ${value}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "ruta": value,
                "tipo": tipo
            }
        }
        ).then((res) => res.blob())
            .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
                var _url = window.URL.createObjectURL(blob);
                window.open(_url, "_blank").focus(); // window.open + focus
            }).catch((err) => {
                console.error(err);
            });
    }

    const desplegarDocumentoPDF = async (value, tipo) => {
        //console.log(`value en desplegarDocumentoPDF ${value}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoPDF`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": sessionStorage.getItem('token'),
            "perfil": sessionStorage.getItem('perfil'),
            "documento": JSON.stringify(value),
            "tipo": tipo
          },
      
        }
        ).then((res) => res.blob())
          .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
            var _url = window.URL.createObjectURL(blob);
            window.open(_url, "_blank").focus(); // window.open + focus
          }).catch((err) => {
            console.error(err);
          });
      }

    const cargarProyectos = async () => {

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${idResponsable}/false/${sessionStorage.getItem('idEntidad')}`, { //Siempre es gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en Adquisición')
            return
        }
        else {
            //console.log('si hay proyectos')
            const data = await res.json()
            //console.log(data)

            setProyectos(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            //console.log(`ANIO ${plan.anio}`)
            setAnio(plan.anio)
            await cargarFechas(plan.anio)
        }
    }

    const cargarFechas = async (anio) => {

        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()
        //console.log(`ENTIDAD ${JSON.stringify(entidadLeida)}`)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        if (res.status === 404) {
            setMensaje('Aún no se ha establecido la configuración de fechas, solicite a la Asistencia Administrativa que la registre')
            setOpen(true)
            setSinConfiguracionFechas(true)
        }
        //console.log(`FECHAS LEIDAS ${fechasLeidas.activarMontosPrioridad2}`)
        setFechas(fechasLeidas)
        const fechaCierreAdquisiciones = new Date(fechasLeidas.cierreAdquisiciones)
        fechaCierreAdquisiciones.setDate(fechaCierreAdquisiciones.getDate() + 1);
        //console.log(`fechaCierreAdquisiciones ${fechaCierreAdquisiciones}`)                            
        if (Date.now() >= Date.parse(fechaCierreAdquisiciones)) {//console.log(`Entró a true ${Date.now()} --- ${Date.parse(fechaCierreAdquisiciones)}` )
            setExpiroFecha(true)
        }
        else {
           //console.log('entró a false')
            setExpiroFecha(false)
        }
    }

    const { idSolicitud, setIdSolicitud, seEnviaCorreo, verificarDisponible } = props;

    useEffect(() => {
        (async () => {
            await cargarProyectos()

            if (idSolicitud) {
                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/adquisiciones/${idSolicitud}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const adquisicion = await res.json()
                setProductoServicio(adquisicion.productoServicio)
                setMonto(adquisicion.monto)
                const fechaExp = new Date(adquisicion.fechaExpiracion)
                fechaExp.setDate(fechaExp.getDate() + 1);
                setFechaExpiracion(fechaExp)
                setAdquisicion({ ...adquisicion, documentos: new FormData() })
                setObservaciones(adquisicion.observaciones)
                setJustificacion(adquisicion.justificacion)
                const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${adquisicion.idPartidaProyecto}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const partida = await resPartida.json()
                setPartida(partida)

                const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${partida.idProyectoPlan}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const proyecto = await resProyecto.json()
                setProyecto(proyecto)
                const resPartidasProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${proyecto.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const partidasProyectoLectura = await resPartidasProyecto.json()
                //Mostrar sólo las no 5000
                //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)

                if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                    setErrorProyectoSinPartidas(false)
                    setHelperTextProyectoSinPartidas('')
                    setPartidasProyecto(partidasProyectoLectura)
                }
                else {
                    setErrorProyectoSinPartidas(true)
                    setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                }
            }
        })()
        // eslint-disable-next-line
    }, [idSolicitud])

    const handleUpdate = async (e) => {
        e.preventDefault()
        setLoading(true)
        adquisicion.idPartidaProyecto = partida.idPartidaProyecto
        adquisicion.productoServicio = productoServicio
        adquisicion.monto = monto
        adquisicion.fechaExpiracion = fechaExpiracion
        adquisicion.observaciones = observaciones
        adquisicion.justificacion = justificacion
        // Si se subió otra cotización se añade a la adquisición
        if (cotizacion) {
            const archivos = new FormData();
            archivos.append('cotizacion', cotizacion);

            const resUpload = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadCotizaciones`, {
                method: "POST",
                body: archivos
            })

            const datos = await resUpload.json()
            adquisicion.rutaCotizacion = datos.ruta
        }
        if (!rutaPDF) {
            if (adquisicion.documentos.get('PDF')) {
                const archivoPDF = new FormData();
                archivoPDF.append('factura', adquisicion.documentos.get('PDF'));
                const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    headers: { "escomprobante": true},
                    method: "POST",
                    body: archivoPDF
                })
                const rutaPDF = (await resUploadPDF.json()).ruta
                adquisicion.rutaPDF = rutaPDF
            }
        }
        if (!pedido) {
            if (adquisicion.documentos.get('pedido')) {
                const archivoPDF = new FormData();
                archivoPDF.append('factura', adquisicion.documentos.get('pedido'));
                const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    headers: { "escomprobante": true},
                    method: "POST",
                    body: archivoPDF
                })
                const rutaPDF = (await resUploadPDF.json()).ruta
                adquisicion.pedido = rutaPDF
            }
        }
        //console.log(`adquisicion.rutaPDF ${adquisicion.rutaPDF}`)
        //console.log(`adquisicion.pedido ${adquisicion.pedido}`)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/adquisiciones/${adquisicion.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({
                idSolicitante: idResponsable,
                anio,
                adquisicion,
                idProyecto: proyecto.id,
                claveProyecto: proyecto.clave,
                descripcionProyecto: proyecto.descripcion,
                partida,
                seEnviaCorreo
            })
        })


        const data = await res.json()
        if (res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        if (data.message) {
            setOpen(true)
            setMensaje(data.message)
            setLoading(false)
            return
        }
        else {
            setOpen(true)
            setMensaje("Se actualizó la solicitud.")
            setLoading(false)
        }

    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        const archivos = new FormData();

        //console.log(`Antes de append ${cotizacion.name}`)
        archivos.append('cotizacion', cotizacion);

        const resUpload = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadCotizaciones`, {
            method: "POST",
            body: archivos
        })

        const datos = await resUpload.json()

        //document.getElementById('archivo').submit()
        const adquisicion = { idPartidaProyecto: partida.idPartidaProyecto, productoServicio, monto, fechaExpiracion, rutaCotizacion: datos.ruta, observaciones, justificacion /*Poner documentos de factura*/ }


        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/adquisicion`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
            },
            body: JSON.stringify({
                idSolicitante: idResponsable,
                anio,
                adquisicion,
                idProyecto: proyecto.id,
                claveProyecto: proyecto.clave,
                descripcionProyecto: proyecto.descripcion,
                partida,
                idEntidad: sessionStorage.getItem('idEntidad'),
                seEnviaCorreo
            })
        })


        const data = await res.json()
        if (res.status === 200) {
            setSeverity('success')
            setProyecto(null)
            setPartidasProyecto([])
            setFechaExpiracion(null)
            setPartida(null)
            setMonto(null)
            setObservaciones(null)
            setJustificacion(null)
            setIdSolicitud(data.solicitud.id)
        }
        else
            setSeverity('error')
        if (data.message) {
            setOpen(true)
            setMensaje(data.message)
            setLoading(false)
            return
        }
        else {
            setOpen(true)
            setMensaje("Se registró la solicitud.")
            setLoading(false)
        }
    }
    return (
        <>
            {expiroFecha ? <>La fecha para el registro de solicitudes de adquisición ha expirado.</> :
                <form onSubmit={idSolicitud ? handleUpdate : handleSubmit}>
                    <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.clave === '' ? option.descripcion : option.clave + '-' + option.descripcion}
                                value={proyecto ? proyecto : null}
                                onChange={async (event, newValue) => {
                                   // console.log(newValue)
                                    setProyecto(newValue)

                                    if (newValue) {
                                        const res2 = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${newValue.id}`, {
                                            method: "GET",
                                            headers: {
                                                "Content-Type": "application/json",
                                                "x-access-token": sessionStorage.getItem('token'),
                                                "perfil": sessionStorage.getItem('perfil')
                                            }
                                        })
                                        const partidasProyectoLectura = await res2.json()
                                        //console.log(`partidasProyectoLectura ${JSON.stringify(partidasProyectoLectura)}`)
                                        //Mostrar sólo las no 5000
                                        //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)

                                        if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                                            setErrorProyectoSinPartidas(false)
                                            setHelperTextProyectoSinPartidas('')
                                            setPartidasProyecto(partidasProyectoLectura)
                                        }
                                        else {
                                            setErrorProyectoSinPartidas(true)
                                            setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                                        }
                                    }

                                }}
                                defaultValue={proyecto ? proyecto : {}}
                                id="proyecto"
                                name="proyecto"
                                options={proyectos}
                                renderInput={(params) => <TextField {...params} label={`Proyecto`} focused helperText={helperTextProyectoSinPartidas} error={errorProyectoSinPartidas} sx={{ width: '100%' }} multiline />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            {partidasProyecto ? partidasProyecto.length > 0 ?
                                <Autocomplete
                                    isOptionEqualToValue={(option, value) => option.idPartidaProyecto === value.idPartidaProyecto}
                                    getOptionLabel={(option) => option.clave + '-' + option.concepto}
                                    value={partida ? partida : null}
                                    onChange={async (event, newValue) => {
                                        //console.log(`newValue ${newValue}`)
                                        setPartida(newValue)
                                    }}
                                    id="partida"
                                    name="partida"
                                    options={partidasProyecto}
                                    sx={{ width: '100%' }}
                                    renderInput={(params) => <TextField {...params} label={`Partida`} focused multiline />}
                                />
                                : <></> : <></>}

                        </Grid>
                        {partida ?
                            <>
                                <Grid item xs={12} sm={4}>
                                    <TextField maxRows={5} label={`Producto/Servicio`} id='productoServicio' name='productoServicio' focused required multiline sx={{ width: '100%' }} onChange={(e) => {
                                        const valor = e.target.value
                                        setProductoServicio(valor)
                                    }} value={productoServicio} />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField name='monto' label="Monto" required onChange={(e) => {
                                        const valor = e.target.value
                                        const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                                        const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                                        fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                                        let montoDisponible = Number(partida.prioridad1Disponible)
                                        if (Date.now() >= Date.parse(fechaPrioridad2)) {
                                            montoDisponible = (Number(montoDisponible) + Number(partida.prioridad2Disponible)).toFixed(2)
                                        }
                                        //console.log(`fecha prioridad 2 ${fechaPrioridad2}`)

                                        if (verificarDisponible() && Number(valorNumerico) > (Number(montoDisponible) + Number(adquisicion && adquisicion.monto ? adquisicion.monto : 0))) {
                                            setErrorMonto(true)
                                            setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number(montoDisponible) + Number(adquisicion && adquisicion.monto ? adquisicion.monto : 0))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                        }
                                        else {
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                        }
                                        setMonto(valorNumerico)
                                    }} InputProps={{
                                        inputComponent: NumberFormatMoney,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }} value={monto} helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />
                                    <Tooltip title={<> El monto (con iva) especificado en la cotización/pedido del producto o servicio que se desea adquirir. </>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip>
                                </Grid>
                                {/*idSolicitud ? <>
                                    <Grid item xs={12} sm={4}>
                                        <TextField label={'Factura PDF'} id='documentoPDF' name='documentoPDF' focused type='file' accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} onChange={async (event) => {
                                            adquisicion.documentos.delete('PDF')
                                            const file = event.target.files[0]
                                            if (event.target.value) {
                                                if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                                    setHelperTextDocumentoPDF('')
                                                    setErrorDocumentoPDF(false)
                                                }
                                                else {
                                                    setHelperTextDocumentoPDF('Formato de archivo no válido, se requiere PDF')
                                                    setErrorDocumentoPDF(true)
                                                    return
                                                }
                                                if (file.size > 5242880) {
                                                    setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                                                    setErrorDocumentoPDF(true)
                                                    return
                                                }
                                                else {
                                                    setHelperTextDocumentoPDF('')
                                                    setErrorDocumentoPDF(false)
                                                }
                                                //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                                // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                                
                                                setHelperTextDocumentoPDF('')
                                                setErrorDocumentoPDF(false)
                                                
                                            }

                                            adquisicion.documentos.append('PDF', file)
                                        }} sx={{ width: '100%' }} />
                                        {adquisicion.rutaPDF ?
                                            <Link style={{ cursor: 'pointer' }} onClick={async () => { await mostrarDocumento(adquisicion.rutaPDF, 'pdf') }} target='_blank'>{colocarNombreFactura(adquisicion.rutaPDF)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                            <></>
                                        }
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField label={'Pedido PDF, PNG, JPG, JPEG'} id='pedido' name='pedido' focused type='file' helperText={helperTextPedido} error={errorPedido} onChange={async (event) => {
                                            adquisicion.documentos.delete('pedido')
                                            const file = event.target.files[0]
                                            if (event.target.value) {
                                                if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf") || event.target.value.endsWith(".PNG") || event.target.value.endsWith(".png") || event.target.value.endsWith(".JPG") || event.target.value.endsWith(".jpg") || event.target.value.endsWith(".JPEG") || event.target.value.endsWith(".jpeg")) {
                                                    setHelperTextPedido('')
                                                    setErrorPedido(false)
                                                }
                                                else {
                                                    setHelperTextPedido('Formato de archivo no válido, se requiere PDF, PNG o JPG')
                                                    setErrorPedido(true)
                                                    return
                                                }
                                                if (file.size > 5242880) {
                                                    setHelperTextPedido('El tamaño del archivo debe ser menor a 5MB')
                                                    setErrorPedido(true)
                                                    return
                                                }
                                                else {
                                                    setHelperTextPedido('')
                                                    setErrorPedido(false)
                                                }
                                                //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                                // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                               
                                                setHelperTextPedido('')
                                                setErrorPedido(false)
                                               
                                            }
                                            //console.log(`Files[0] ${file.name}`)
                                            adquisicion.documentos.append('pedido', file)
                                        }} sx={{ width: '100%' }} />
                                        {adquisicion.pedido ?
                                            <Link style={{ cursor: 'pointer' }} onClick={async () => { await desplegarDocumentoPDF(adquisicion, 'pedido') }} target='_blank'>{colocarNombreFactura(adquisicion.pedido)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                            <></>
                                        }
                                    </Grid></>
                                    : <></>
                                */}
                                <Grid item xs={12} sm={4}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                        <DatePicker required label="Fecha de Expiración de la Cotización"
                                            value={`${fechaExpiracion}`}
                                            onChange={(newValue) => {
                                                setFechaExpiracion(newValue)
                                            }}
                                            renderInput={(params) => <TextField {...params} name="fechaExpiracion" id="fechaExpiracion" required={idSolicitud ? false : true} focused variant='outlined' style={{ width: '100%' }} />}
                                        />
                                    </LocalizationProvider>
                                    <Tooltip title={<> Fecha de vigencia especificada en la cotización </>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField label={`Cotización PDF`} id='cotizacion' name='cotizacion' focused required={idSolicitud ? false : true} type='file' accept="application/pdf" helperText={helperTextCotizacion} error={errorCotizacion} onChange={(event) => {
                                        const file = event.target.files[0]
                                        if (event.target.value) {
                                            if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                                setHelperTextCotizacion('')
                                                setErrorCotizacion(false)
                                            }
                                            else {
                                                setHelperTextCotizacion('Formato de archivo no válido, se requiere PDF')
                                                setErrorCotizacion(true)
                                                return
                                            }
                                            if (file.size > 5242880) {
                                                setHelperTextCotizacion('El tamaño del archivo debe ser menor a 5MB')
                                                setErrorCotizacion(true)
                                                return
                                            }
                                            else {
                                                setHelperTextCotizacion('')
                                                setErrorCotizacion(false)
                                            }
                                            //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                            // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                            /*if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
                                            {
                                                setHelperTextCotizacion('')
                                                setErrorCotizacion(false)
                                            }
                                            
                                            else {
                                                setHelperTextCotizacion('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                                                setErrorCotizacion(true)
                                                return
                                            }*/
                                        }
                                        //console.log(`Files[0] ${file.name}`)
                                        setCotizacion(file)
                                    }} sx={{ width: '100%' }} />
                                    {adquisicion.rutaCotizacion ?
                                        <Link style={{ cursor: 'pointer' }} onClick={async () => { await mostrarDocumento(adquisicion.rutaCotizacion, 'pdf') }} target='_blank'>{colocarNombreCotizacion(adquisicion.rutaCotizacion)}<PreviewTwoToneIcon></PreviewTwoToneIcon></Link> :
                                        <></>
                                    }
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <TextField maxRows={5} label={`Observaciones`} id='observaciones' name='observaciones' focused multiline sx={{ width: '100%' }}
                                        onChange={(e) => {
                                            const valor = e.target.value
                                            setObservaciones(valor)
                                        }
                                        } value={observaciones} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <TextField maxRows={5} label={`Justificación`} id='justificacion' name='justificacion' focused multiline sx={{ width: '100%' }}
                                        onChange={(e) => {
                                            const valor = e.target.value
                                            setJustificacion(valor)
                                        }
                                        } value={justificacion} />
                                </Grid>


                            </>
                            : <></>

                        }
                    </Grid>
                    {
                        idSolicitud ? <Button sx={{ marginTop: 5 }} variant='contained' color='primary' type='submit' disabled={errorMonto || errorProyectoSinPartidas || errorDocumentoPDF || sinConfiguracionFechas || loading}>
                            Actualizar
                        </Button> : (
                            partida ?
                                <Grid item sx={{ marginTop: 5 }}>
                                    <Button variant='contained' color='primary' type='submit' disabled={errorMonto || errorProyectoSinPartidas || errorDocumentoPDF || sinConfiguracionFechas || loading}>
                                        Solicitar
                                    </Button>
                                </Grid> : <></>
                        )
                    }
                </form>
            }
            <Box sx={{ width: '100%' }}>
                <Collapse in={open}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}